import moment from 'moment';
import React, { useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import momentDate from './MomentDate';

const SearchDateRange = ({ handleSearchDateRange, setSearchParams, className = '' }) => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const componentId = useRef(`searchDateRange-${Math.random().toString(36).substring(2, 15)}`).current;
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);

    const handleDateRange = (e) => {
        const valueRangeDate = e.target.value;
        const today = moment().format('YYYY-MM-DD');
        const dateMoment = momentDate(today, valueRangeDate);
        setStartDate(dateMoment);
        setEndDate(today);
    };

    const handleDateChange = (date, name) => {
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };

    const handleSearch = () => {
        const startDateFormat = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormat = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        setSearchParams({ page: 1 });
        handleSearchDateRange(startDateFormat, endDateFormat, componentId);
    };
    return (
        <div className={`rsm-stt__srh ${className}`} data-search-date-range-id={componentId}>
            <div className="rsm-stt__lf">
                {['oneMonth', 'threeMonth', 'sixMonth', 'directMonth'].map((term) => (
                    <React.Fragment key={term}>
                        <input
                            type="radio"
                            name={`term-${componentId}`}
                            value={term}
                            id={`${term}-${componentId}`}
                            onClick={handleDateRange}
                        />{' '}
                        {/* Unique name and id */}
                        <label htmlFor={`${term}-${componentId}`} className="rsm-stt__label">
                            {term === 'oneMonth' && '1개월'}
                            {term === 'threeMonth' && '3개월'}
                            {term === 'sixMonth' && '6개월'}
                            {term === 'directMonth' && '직접입력'}
                        </label>
                    </React.Fragment>
                ))}
            </div>
            <div className="rsm-stt__rt">
                <div className="rsm-stt__rang">
                    <div className="datepicker-child">
                        <DatePicker
                            ref={startDateRef}
                            onChange={(date) => handleDateChange(date, 'startDate')}
                            locale={'ko'}
                            placeholderText={'YYYY/MM/DD'}
                            dateFormat={'yyyy/MM/dd'}
                            selected={startDate}
                            maxDate={endDate || null}
                            id={`start-date-${componentId}`}
                        />
                        <i
                            className="icon icon-date"
                            id="start-date-icon"
                            onClick={() => startDateRef.current.setFocus()}
                        />
                    </div>
                    <span>~</span>
                    <div className="datepicker-child">
                        <DatePicker
                            ref={endDateRef}
                            onChange={(date) => handleDateChange(date, 'endDate')}
                            locale={'ko'}
                            placeholderText={'YYYY/MM/DD'}
                            dateFormat={'yyyy/MM/dd'}
                            selected={endDate}
                            minDate={startDate || null}
                            id={`end-date-${componentId}`}
                        />
                        <i
                            className="icon icon-date"
                            id="start-date-icon"
                            onClick={() => endDateRef.current.setFocus()}
                        />
                    </div>
                </div>
                <button type="button" className="rsm-stt__btn" onClick={handleSearch}>
                    조회
                </button>
            </div>
        </div>
    );
};

export default SearchDateRange;
